import angular from 'angular';
import Lang from './lang';

/**
 * @class
 * @public
 */
export default class Repre {
	/**
	 * Instantiates a Repre object
	 *
	 * @param {any} repre
	 * @class
	 */
	constructor(repre = undefined) {
		/**
		 * K identifier
		 *
		 * @type {import('@knitiv/api-client-javascript').KNode | undefined}
		 */
		this.kid = repre?.kid;

		/**
		 * Repre language
		 *
		 * @type {Lang}
		 */
		this.lang = new Lang(repre?.lang);
		if (!repre?.lang) {
			this.lang.setUniversel();
		}

		/**
		 * Repre type
		 *
		 * @type {import('@knitiv/api-client-javascript').TypeKid}
		 */
		this.type = repre?.type ?? 'K_NODE;STRING';

		/**
		 * Repre value
		 *
		 * @type {any}
		 */
		this.value = repre?.name ?? repre?.value ?? null;

		/**
		 * Flag to determine if the repre should be read-only
		 *
		 * @type {boolean}
		 */
		this.readOnly = repre?.readOnly ?? false;
	}

	export() {
		return this.value === undefined || this.value === null ? undefined : {
			lang:  this.lang,
			kid:   this.kid,
			type:  this.type,
			value: typeof this.value === 'string' ? this.value : angular.toJson(this.value),
		};
	}

	exportForObjectSet() {
		return {
			lang:  this.lang,
			kid:   this.kid,
			type:  this.type,
			name:  typeof this.value === 'string' ? this.value : angular.toJson(this.value),
		};
	}
}
